module.exports = __webpack_public_path__ + "static/media/vencimientostickets-07-verde.59a1a73d.svg";